import * as React from "react";

import { useDateFnsLocale } from "@racoon/i18n";

import type { JobIncidentNote } from "~/shared/lib/job-incident";
import { IncidentChip } from "~/shared/ui/incident-chip";
import { formatReportTime } from "../model/report-time";

/** Figma: the job's saved reason over its photos, with when it was recorded. */
export const JobIncidentBadge: React.FC<{
  note: JobIncidentNote;
  label: string;
  recordedAt?: Date | null;
}> = ({ note, label, recordedAt }) => {
  const dateLocale = useDateFnsLocale();
  return (
    <IncidentChip
      tone={note.kind}
      title={note.explanation}
      className="flex h-8 shrink-0 items-center gap-2 rounded-lg px-3 text-sm"
    >
      <span>{label}</span>
      {recordedAt && <span>{formatReportTime(recordedAt, dateLocale)}</span>}
    </IncidentChip>
  );
};
